import { render, staticRenderFns } from "./BowWrapper.vue?vue&type=template&id=7b2321ba&"
import script from "./BowWrapper.vue?vue&type=script&lang=js&"
export * from "./BowWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports